export type ResizeCorner = 'nw' | 'ne' | 'sw' | 'se'

export const RESIZE_CORNERS: readonly ResizeCorner[] = ['nw', 'ne', 'sw', 'se']

export const RESIZE_HOTSPOT_MAX_PX = 24
export const RESIZE_HOTSPOT_EDGE_FRACTION = 0.2
export const RESIZE_WEDGE_ARM_PX = 14
export const RESIZE_HOTSPOT_BLEED_PX = 4

export type ResizeHotspotGeometry = {
  width: number
  height: number
  clipPath: string | undefined
}

const capToEdge = (edge: number): number =>
  Number.isFinite(edge)
    ? Math.max(
        0,
        Math.round(
          Math.min(RESIZE_HOTSPOT_MAX_PX, edge * RESIZE_HOTSPOT_EDGE_FRACTION),
        ),
      )
    : RESIZE_HOTSPOT_MAX_PX

const cornerClipPath = (corner: ResizeCorner): string => {
  const arm = `${RESIZE_WEDGE_ARM_PX + RESIZE_HOTSPOT_BLEED_PX}px`
  const inner = `calc(100% - ${arm})`
  switch (corner) {
    case 'se':
      return `polygon(0 ${inner}, ${inner} ${inner}, ${inner} 0, 100% 0, 100% 100%, 0 100%)`
    case 'sw':
      return `polygon(100% ${inner}, ${arm} ${inner}, ${arm} 0, 0 0, 0 100%, 100% 100%)`
    case 'ne':
      return `polygon(0 ${arm}, ${inner} ${arm}, ${inner} 100%, 100% 100%, 100% 0, 0 0)`
    case 'nw':
      return `polygon(100% ${arm}, ${arm} ${arm}, ${arm} 100%, 0 100%, 0 0, 100% 0)`
  }
}

export const resizeHotspotGeometry = (
  boxWidth: number,
  boxHeight: number,
  corner: ResizeCorner = 'se',
): ResizeHotspotGeometry => {
  const width = capToEdge(boxWidth) + RESIZE_HOTSPOT_BLEED_PX
  const height = capToEdge(boxHeight) + RESIZE_HOTSPOT_BLEED_PX
  const arm = RESIZE_WEDGE_ARM_PX + RESIZE_HOTSPOT_BLEED_PX
  if (width <= arm || height <= arm) {
    return { width, height, clipPath: undefined }
  }
  return { width, height, clipPath: cornerClipPath(corner) }
}
